import { Select } from "antd";
import { useDispatch, useGlobal } from "reactn";
import { useTranslation } from "react-i18next";
import React from "react";

const { Option } = Select;

export const LanguageSelect = () => {
	const { t } = useTranslation();
	const changeLanguage = useDispatch("changeLanguage");
	const [language] = useGlobal("language");

	const languagues = {
		es: t("spanish"),
		en: t("english"),
		pt: t("portuguese"),
	};

	const handleSetLanguage = (languague) => {
		const key = Object.keys(languagues).find(
			(k) => languagues[k] === languague
		);

		changeLanguage(key);
	};

	return (
		<Select
			className="select"
			size="small"
			bordered={false}
			value={languagues[language.selected]}
			defaultValue={languagues[language.selected]}
			removeIcon={true}
			onChange={handleSetLanguage}
		>
			{Object.values(languagues).map((language) => (
				<Option key={language} value={language}>
					{language}
				</Option>
			))}
		</Select>
	);
};
